import { kratosIntegration } from '@myme/utils';

export const handleLogout = async (token: string) => {
  return kratosIntegration.request.submitSelfServiceLogoutFlow(token);
};
